import React from 'react';

import { ArrowUpRightIcon } from '@infinex/ui-icons';
import { Text } from '@infinex/ui/components';

import { smartTruncate } from '../helpers';

interface EvmContractProps {
  contractAddress: string;
  contractName?: string;
  onExplorerClick: (address: string) => void;
}

export function EvmContract({
  contractAddress,
  contractName,
  onExplorerClick,
}: EvmContractProps) {
  if (!contractAddress && !contractName) return null;

  return (
    <div className="flex items-center justify-between">
      <Text className="text-default text-sm font-medium">Contract</Text>
      <div
        className="group flex cursor-pointer items-center gap-1.5"
        onClick={() => onExplorerClick(contractAddress)}
      >
        <Text className="text-emphasis group-hover:text-brand text-sm font-medium transition-colors">
          {smartTruncate(contractName || contractAddress, 30)}
        </Text>
        <ArrowUpRightIcon className="fill-tertiary group-hover:fill-brand size-4 transition-colors" />
      </div>
    </div>
  );
}
